import dataService from 'services/dataService';
import { API_HOSPITAL_PREVENTION } from 'services/dataService/resources';

const hospitalPrevention = {
  state: {},
  reducers: {
    setDischarge: (state, payload) => ({
      ...state,
      ...payload,
    }),
  },
  effects: () => ({
    async submit(postData) {
      const { error, data } = await dataService.createOne(
        API_HOSPITAL_PREVENTION,
        postData,
      );
      return { error, data };
    },
  }),
};

export default hospitalPrevention;
